import { get } from '../../../../util/api'
import * as type from './type'
import Globals from '../../../globals'
import initializeImplantConsultationAndFindings from '../anamnesis/initialize-implant-consultation-and-findings'
import {
    IMPLANT_CONSULTATION_AND_FINDINGS,
    IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
    IMPLANT_SURGERY_DOCUMENTATION,
} from '../anamnesis/const'
import initializeImplantTreatmentPhysicianAssessment
    from '../anamnesis/initialize-implant-treatment-physician-assesment'
import initializeImplantSurgeryDocumentation from '../anamnesis/initialize-implant-surgery-documentation'

export const findByCustomerIdRequest = () => ({
    type: type.FIND_BY_CUSTOMER_ID_REQUEST,
    payload: {},
})

export const findByCustomerIdSuccess = anamnesisList => ({
    type: type.FIND_BY_CUSTOMER_ID_SUCCESS,
    payload: {
        anamnesisList,
    },
})

export const findByCustomerIdError = error => ({
    type: type.FIND_BY_CUSTOMER_ID_ERROR,
    payload: {
        error,
    },
})

const enrichCreatedByUser = (state, anamnesis) => {
    return {
        ...anamnesis,
        createdByUser: Globals.selector.selectUserDisplayNameById(
            state,
            anamnesis.createdByUserId
        ),
    }
}

const enrichAnamnesisList = (state, anamnesisList) => {
    return anamnesisList.map(anamnesis => {
        if (anamnesis.templateKey === IMPLANT_CONSULTATION_AND_FINDINGS){
            anamnesis = initializeImplantConsultationAndFindings(anamnesis)
        }
        if (anamnesis.templateKey === IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT){
            anamnesis = initializeImplantTreatmentPhysicianAssessment(anamnesis)
        }
        if (anamnesis.templateKey === IMPLANT_SURGERY_DOCUMENTATION){
            anamnesis = initializeImplantSurgeryDocumentation(anamnesis)
        }
        anamnesis = enrichCreatedByUser(state, anamnesis)

        return anamnesis
    })
}

export const findByCustomerId = customerId => (dispatch, getState) => {
    const state = getState()
    dispatch(findByCustomerIdRequest())

    // this endpoint return all anamnesis with customerId equals to the
    // query-parma ordered by creation date DESC.
    get('/api/anamnesis/find-by-customer-id?customerId=' + customerId)
        .then(anamnesisList => {
            anamnesisList = enrichAnamnesisList(state, anamnesisList)
            dispatch(findByCustomerIdSuccess(anamnesisList))
        })
        .catch(error => {
            dispatch(findByCustomerIdError(error))
        })
}
export const toggleAnamnesis = () => ({
    type: type.TOGGLE_ANAMNESIS,
})

export const toggleInfoLegend = () => ({
    type: type.TOGGLE_INFO_LEGEND,
})



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/list/action.js